// TODO the Individual parser must support @id in addition to url, refactor...

import jsonld from 'jsonld'

// TODO temporary solution adding the WoB ontology to the context.
// Preferably this should be based on reading the models from ADT
import recContext from './rec-context.json'
import woboContext from './wobo-context.json'
// The rec context will override the wobo context in case of overlaps.
const context = Object.assign({}, woboContext, recContext)

console.log('CONTEXT', context)

const adt = {
  id: '$dtId',
  metadata: '$metadata',
  model: '$model',
  updated: '$lastUpdateTime',
  etag: '$etag',
}

// TODO remove use of lowercase for the relationship names...
const componentModels = {
  area: 'ArchitectureArea',
  capacity: 'ArchitectureCapacity',
  lastknownvalue: 'ObservationEvent',
}

// const context = {
//   RealEstate: 'https://w3id.org/rec#RealEstate',
//   Building: 'https://w3id.org/rec#Building',
//   modified: 'http://purl.org/dc/terms/modified',
//   area: { '@id': 'https://w3id.org/rec#area', '@type': '@id' },
//   capacity: { '@id': 'https://w3id.org/rec#capacity', '@type': '@id' },
// }

// TODO perhasp rename and place with utilitites below... iri(dmti)
function shorten(identity) {
  const prefixed = identity.split(';').shift().split(':')
  const name = prefixed.pop()
  // const ontology = prefixed.pop().toLowerCase()
  return name
}

let idIndex = 0
function idFactory() {
  idIndex++
  return 'anonymous:' + idIndex.toString().padStart(4, '0')
}

async function adtParser(
  twin,
  expand = true,
  parentId = null,
  componentKey = null
) {
  const node = {}
  const components = []
  for (const [key, value] of Object.entries(twin)) {
    switch (key) {
      case adt.id:
        node['@id'] = value
        break
      case adt.metadata:
        // TODO if model isnt set, an generic class (an individual perhaps) must be assigend
        if (value[adt.model]) {
          node['@type'] = shorten(value[adt.model])
        }

        // TODO can the ADT model be an array, ie multi inheritance? if so, refactor...s
        // Strip fractional seconds but preserve UTC 'Z' suffix for correct timezone handling
        node['modified'] = value[adt.updated].split('.').shift() + 'Z'
        break
      case adt.etag:
        break
      default:
        // Manage components. ADT components are transformed to anonymous individuals.
        // TODO parse the component models object...
        // TODO remove use of lowercase for the relationship names...
        if (
          ['area', 'capacity', 'lastknownvalue'].includes(key.toLowerCase())
        ) {
          // The parser returns an array. Since the component cannot be nested there'll be only one entry.
          // Pass parent ID and component key to create deterministic component IDs
          const [component] = await adtParser(
            value,
            false,
            node['@id'],
            key.toLowerCase()
          )
          // TODO remove use of lowercase for the relationship names...
          component['@type'] = componentModels[key.toLowerCase()]
          components.push(component)
          // Add the object property to the created component individual.
          node[key] = component['@id']
          // if (key.toLowerCase() == 'lastknownvalue')
          //   console.log('ADT PARSER LKV', twin, expand, node)
          break
        }
        // Manage properties.
        node[key] = value
    }
  }
  // If no ID is included assign one, ie. a blank node, used for components.
  // For components, use deterministic ID based on parent ID and component type (e.g., "parent-id.area")
  // This ensures components have stable IDs across cache hydration and API sync cycles
  if (!node['@id']) {
    if (parentId && componentKey) {
      // Component: use parent.componentType pattern with dot notation
      node['@id'] = `${parentId}.${componentKey}`
    } else {
      // Fallback for edge cases (should rarely happen)
      node['@id'] = idFactory()
    }
  }

  // If no type is set assign one to ensure the JSON-LD expander works.
  // TODO unclear why the model interface for components is empty while testing.
  if (!node['@type']) {
    node['@type'] = 'AnonymousModel'
  }

  const compacted = Object.assign({ '@context': context }, node)
  // const expanded = await jsonld.expand(compacted)
  // console.log('JSON-LD', node['@id'], compacted, expanded)

  // Parent individual first, then components. This ordering ensures that when
  // events are dispatched sequentially, the parent's edges create aggregate
  // entries before components arrive, allowing components to be correctly
  // recognized and attached to their parent during cache processing.
  const allNodes = [compacted, ...components]
  if (expand) {
    const expandedResults = await Promise.allSettled(
      allNodes.map((c) => jsonld.expand(c))
    )
    return expandedResults.map((v) => v.value)
  } else return allNodes
}

// Utilities for the adt client.

// TODO prefixes and DTMI urns should perhapos be available to whole module... both ar ereally prefixes, one for IRIs and one for DTMIs
// TODO very rudimentary implementaion, eg the version is always 1,
// perhaps read the models (cannot rely on read individuals as one may want to create a model that hasnt been read yet)...
function dtmi(iri) {
  const prefixes = {
    wobo: 'https://webofbuildings.com/ontology/',
    brick: 'https://brickschema.org/schema/Brick#',
    rec: 'https://w3id.org/rec#',
  }
  const DTMI = {
    brick: 'dtmi:org:brickschema:schema:Brick',
    rec: 'dtmi:org:w3id:rec',
    wobo: 'dtmi:com:webofbuildings:ontology',
  }
  const [prefix, ns] = Object.entries(prefixes).find(([, ns]) =>
    iri.startsWith(ns)
  )
  if (prefix) {
    const namespace = DTMI[prefix]
    // The DTMI in DTDLv2 doesnt allow points, nor dashes.
    const short = iri.replace(ns, ':').replace('.', '_').replace('-', '_')
    const version = ';1'
    return namespace + short + version
  } else throw Error('Cannot convert id to dtmi, not a known namespace.')
}

// Returns a DTDL
// Parameter id is an IRI string.
// TODO optimize by pre processing the context... or cache results.
function toDTDL(iri) {
  return dtmi(iri)
}

export { adtParser, toDTDL }
